'use client';

import { datadogRum, RumEvent } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { datadogLogs } from '@datadog/browser-logs';

const InitDataDog = ({
  service,
  version,
  userJourney,
  userId,
  storeId,
  shopId,
}: {
  service: string;
  version: string;
  userJourney?: string;
  userId?: string;
  storeId?: string;
  shopId?: string;
}) => {
  useEffect(() => {
    datadogRum.init({
      applicationId: process.env.NEXT_PUBLIC_SECRET_DATADOG_APP_ID as string,
      clientToken: process.env
        .NEXT_PUBLIC_SECRET_DATADOG_CLIENT_TOKEN as string,
      site: 'datadoghq.eu',
      service,
      env: process.env.NEXT_PUBLIC_SECRET_DATADOG_ENV as string,
      version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      beforeSend: (event: RumEvent) => {
        if (event.view.url?.includes('/country/')) {
          event.context = {
            ...event.context,
            country: event.view.url.split('/country/')[1].substring(0, 2),
          };

          if (userJourney) {
            event.context.user_journey = userJourney;
          }

          event.view.url = event.view.url.replace(
            /country\/[a-zA-Z]{2}/,
            'country',
          );
        }
        return true;
      },
    });
    datadogRum.setGlobalContextProperty('business_unit', 'bcp');
    datadogRum.setGlobalContextProperty('invoiced_team', 'ce-onebooking-api');
    datadogRum.setGlobalContextProperty('has_error', false);

    datadogRum.startSessionReplayRecording();

    datadogLogs.init({
      clientToken: process.env
        .NEXT_PUBLIC_SECRET_DATADOG_CLIENT_TOKEN as string,
      site: 'datadoghq.eu',
      service,
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      env: process.env.NEXT_PUBLIC_SECRET_DATADOG_ENV as string,
      version,
      forwardConsoleLogs: 'all',
    });
  }, []);

  useEffect(() => {
    if (userId) {
      datadogRum.setUser({ id: userId });
    }
  }, [userId]);

  useEffect(() => {
    if (storeId) {
      datadogRum.setGlobalContextProperty('store_id', storeId);
    }
  }, [storeId]);

  useEffect(() => {
    if (shopId) {
      datadogRum.setGlobalContextProperty('shop_id', shopId);
    }
  }, [shopId]);

  return null;
};

export default InitDataDog;
